// Dynamic pages scritps
const pageBgColor = document.querySelector('[data-bg]')

if (pageBgColor) {
  const bgColor = pageBgColor.dataset.bg
  document.querySelector('body').style.backgroundColor = bgColor
}
